import app from 'app';
import { component } from 'picoapp';

const Search = component(async () => {
});

app.add({
  Search,
});

app.mount();
